import { render, staticRenderFns } from "./PaymentInvoice.vue?vue&type=template&id=ce01fd14&scoped=true&"
import script from "./PaymentInvoice.vue?vue&type=script&lang=js&"
export * from "./PaymentInvoice.vue?vue&type=script&lang=js&"
import style0 from "./PaymentInvoice.vue?vue&type=style&index=0&id=ce01fd14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce01fd14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
